
<template>

    <main class="page" id="collectionsPage">

        <!-- Latest posts -->
        <section class="latest-posts">

            <div class="container py-4">

                <div class="row">

                    <div class="col text-center py-2">

                        <h2 class="text-uppercase">Blog</h2>
                        <div class="divider-image divider-image-2"></div>

                        <form v-if="!noResults && displayContent" class="mt-5 mb-4" action="/search" method="get" style="max-width: 600px;display:block;margin:0 auto;">

                            <label class="sr-only" for="inlineFormInputGroup">Search</label>
                            <div class="input-group">
                                <input v-model="searchQuery" type="text" required class="form-control" id="inlineFormInputGroup" name="search" placeholder="Search ...">
                                <button type="submit" class="btn btn-danger"><i class="fal fa-search"></i> &nbsp; Search</button>
                            </div>
                        </form>

                    </div>
                </div>

                <div class="row" v-bind:class="{'hidden-content': !displayContent}">

                    <div class="col-12 col-sm-10 offset-sm-1">

                        <div class="masonry">

                            <div v-for="blog in blogs" class="grid-item">

                                <blog-tile :blog="blog"></blog-tile>

                            </div>

                        </div>

                    </div>

                </div>

                <div class="row text-center mt-4" v-if="noResults">

                    <div class="col">
                        <p class="lead">Nič blogov ni bilo najdenih ... ponovi iskanje?</p>

                        <form class="mt-5" action="/search" method="get" style="max-width: 600px;display:block;margin:0 auto;">

                            <label class="sr-only" for="inlineFormInputGroup1">Iskanje</label>
                            <div class="input-group">
                                <input v-model="searchQuery" type="text" required class="form-control" id="inlineFormInputGroup1" name="search" placeholder="Iskanje ...">
                                <button type="submit" class="btn btn-danger"><i class="fal fa-search"></i> &nbsp; Išči</button>
                            </div>
                        </form>
                    </div>
                </div>

                <div class="filtering-overlay" v-show="!displayContent">

                    <div class="col-12 col-sm-10 offset-sm-1">

                        <p class="filtering-posts"><i class="fal fa-spin fa-spinner"></i> &nbsp; Why? Searching, that's why.</p>

                    </div>
                </div>

            </div>
        </section>

    </main>

</template>

<script>
    import BlogTile from '../snippets/blog/Tile.vue';
    import Promise from 'promise-polyfill';
    import {mapActions} from 'vuex'

    export default {
        components: {
            "blog-tile": BlogTile
        },
        data () {
            return {
                blogs: [],
                noResults: false,
                displayContent: false,
                searchQuery: ""
            }
        },
        methods: {

            ...mapActions([
                'loadBanners'
            ]),

            displayImage: function(image, width, height) {

                if(!image) return "";

                return window.cms + image.display +
                    (width !== null && typeof width !== "undefined" && !isNaN(width) ? "?w=" + width : "") +
                    (height !== null && typeof height !== "undefined" && !isNaN(height) ?
                        (width !== null && typeof width !== "undefined" && !isNaN(width) ? "&" : "?") + "h=" + height : "");
            },

            getBanners: function() {

                let handle = this;
                let mainBackgroundImage = document.getElementById("mainBackgroundImage");

                this.loadBanners().then(function(banners) {

                    if(banners.length > 0 && banners[0].image !== null && typeof banners[0].image !== "undefined") {

                        mainBackgroundImage.style.backgroundImage = "url("+handle.displayImage(banners[0].image, 2200)+")";
                    }
                });
            }

        },
        mounted: function() {

            let handle = this;

            this.searchQuery = handle.$route.query.search;

            jQuery(document).ready(function() {

                jQuery.ajax({
                    url: window.cms + "blog/search",
                    type: "get",
                    dataType: "json",
                    data: {
                        published: 2,
                        search: handle.$route.query.search
                    },
                    success: function(blogs) {

                        console.log("blogs");
                        console.log(blogs);

                        document.title = "WHY - Search results for '"+ handle.$route.query.search +"'";

                        handle.blogs = blogs.data;

                        if(handle.blogs.length === 0) {

                            handle.noResults = true;

                        } else {

                            setTimeout(function () {

                                initMasonry();

                            }, 250);
                        }

                        handle.displayContent = true;
                    }
                }).fail(function(error) {

                    console.log(error);
                    console.log(error.responseText);
                });
            });

            this.getBanners();

        }
    }
</script>

<style lang="scss">



</style>



// WEBPACK FOOTER //
// src/pages/SearchResults.vue